/* MaxHealth scroll-reveal observer.
   Robustness contract (see DESIGN.md):
   - Content is visible by default. The hidden initial state is armed only
     while <html class="mh-anim-ready"> is present.
   - The inline head script adds mh-anim-ready (skipped under reduced-motion)
     and removes it after a timeout if this script never marks itself ready,
     so a JS load failure can never ship content blank.
   - A 2.5s failsafe reveals everything if IntersectionObserver callbacks
     never fire (hidden tab / headless renderer). */
(function () {
  var root = document.documentElement;

  // Signal to the inline failsafe that the reveal engine loaded.
  window.__mhRevealReady = true;

  // Reduced motion or inline script absent: leave content visible, do nothing.
  if (!root.classList.contains('mh-anim-ready')) return;

  function revealAll() {
    var els = document.querySelectorAll('.mh-reveal:not(.is-in)');
    for (var i = 0; i < els.length; i++) els[i].classList.add('is-in');
  }

  if (!('IntersectionObserver' in window)) {
    revealAll();
    return;
  }

  var io = new IntersectionObserver(
    function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          entries[i].target.classList.add('is-in');
          io.unobserve(entries[i].target);
        }
      }
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
  );

  function observe(scope) {
    var els = (scope || document).querySelectorAll('.mh-reveal:not(.is-in)');
    for (var i = 0; i < els.length; i++) io.observe(els[i]);
  }

  observe();

  // Failsafe: never leave content hidden if callbacks don't fire.
  window.setTimeout(revealAll, 2500);

  // Re-scan sections added/reordered in the Theme Editor.
  document.addEventListener('shopify:section:load', function (e) {
    observe(e.target);
  });
})();
